import { inTableTextInput } from '@utils/component-framework';
import { NoSSR } from '@utils/react';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useUpdateInputMutation } from '../../../../state/mutations/update-input.js';
import { useTaskContext } from '../../context.js';
import { useInputState } from '../../hook.use-input-state.js';
import { TextareaInput } from './atom.textarea-input.js';
import { wrapper, tokens } from './input.text.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function InTableTextInput(props) {
  const context = useTaskContext();
  const update = useUpdateInputMutation();
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => inTableTextInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.input.id])
  });
  const onChange = evt => {
    update(props.taskEntryKey, props.input.id, {
      type: "in-table-text",
      text: evt.currentTarget.value
    });
  };
  const state = useInputState(props.input, inputEntry);
  const shouldHaveValue = props.input.validation.correctAnswers.find(answer => inTableTextInput.cleanText(answer, props.input.validation) !== inTableTextInput.cleanText(inputEntry?.text ?? "", props.input.validation));
  return /*#__PURE__*/jsx(NoSSR, {
    children: /*#__PURE__*/jsxs("span", {
      className: wrapper,
      children: [/*#__PURE__*/jsx(TextareaInput, {
        value: inputEntry?.text,
        state: state,
        readOnly: context === "facit" || context === "readonly",
        onChange: onChange,
        maxWidth: tokens.maxWidth()
      }), state === "incorrect" && /*#__PURE__*/jsx(TextareaInput, {
        value: shouldHaveValue,
        state: "should-have",
        readOnly: true,
        maxWidth: tokens.maxWidth()
      })]
    })
  });
}

export { InTableTextInput };
//# sourceMappingURL=input.text.js.map
